import React from "react";

const FailedDataUi = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "200px" }}
    >
      <div className="text-center">
        <strong className="poppins-semibold fs-4">
          Oops! Something went wrong.
        </strong>
        <div className="">
          We couldn't load the data. Please try again later.
        </div>
      </div>
    </div>
  );
};

export default FailedDataUi;
